import { DatasetExtraFieldSettings } from '@warebee/frontend/data-access-api-graphql';
import { SimulationHqDataRow } from '@warebee/shared/dataset-queries';
import { ItemSetDataTableColumn } from '@warebee/shared/export-converter';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useAssignmentDataTableConfig from '../../../assignment/useAssignmentDataTableConfig';
import useFormatter from '../../../common/useFormatter';
import { ColumnConfig } from '../../../components/DatasetTable';
import FormattedValue from '../../../components/FormattedValue';
import useItemSetDataTableConfig from '../../../itemSet/useItemSetDataTableConfig';
import useLayoutDataTableConfig from '../../../layout/useLayoutDataTableConfig';
import useOrderStatsDataTableConfig from '../../../orders/useOrderStatsDataTableConfig';

function useSimulationHqDataTableConfig(): ColumnConfig<SimulationHqDataRow>[] {
  const { t: tImporter } = useTranslation('importer');
  const { t } = useTranslation('dataset');
  const formatter = useFormatter();
  const activityExtraFields: DatasetExtraFieldSettings[] = []; // = useRecoilValue(feedDatasetExtraFields);

  const itemsFieldSkip: Set<ItemSetDataTableColumn> = new Set([]);
  const locationFieldSkip: Set<string> = new Set(['locationId']);
  const assignmentFieldSkip: Set<string> = new Set([
    'consignee',
    'sku',
    'locationId',
  ]);

  const itemSetFields = useItemSetDataTableConfig().filter(
    f => !itemsFieldSkip.has(f.field),
  ) as ColumnConfig<Partial<SimulationHqDataRow>>[];

  const locationFields = useLayoutDataTableConfig().filter(
    f => !locationFieldSkip.has(f.field),
  ) as any as ColumnConfig<SimulationHqDataRow>[];

  const assignmentFields = useAssignmentDataTableConfig().filter(
    f => !assignmentFieldSkip.has(f.field),
  ) as any as ColumnConfig<SimulationHqDataRow>[];

  const orderStatsFields = useOrderStatsDataTableConfig();

  const feedExtraFields: ColumnConfig<SimulationHqDataRow>[] = _.map(
    activityExtraFields,
    f => ({
      field: f.alias as any,
      title: f.title ?? f.name,
      hasFilter: true,
      hasSearch: true,
    }),
  );

  const columnsConfig: ColumnConfig<SimulationHqDataRow>[] = [
    ...itemSetFields,
    ...orderStatsFields,
    ...locationFields,
    ...assignmentFields,

    {
      field: 'stockUomNetWeight',
      title: t`Weight`,
      hasFilter: true,
      render: (v: number) => (
        <FormattedValue value={formatter.formatWeight(v)} />
      ),
    },
    {
      field: 'stockUomLength',
      title: t`Length`,
      hasFilter: true,
      render: (v: number) => (
        <FormattedValue value={formatter.formatDistance(v, 1000, false)} />
      ),
    },
    {
      field: 'stockUomWidth',
      title: t`Width`,
      hasFilter: true,
      render: (v: number) => (
        <FormattedValue value={formatter.formatDistance(v, 1000, false)} />
      ),
    },
    {
      field: 'stockUomHeight',
      title: t`Height`,
      hasFilter: true,
      render: (v: number) => (
        <FormattedValue value={formatter.formatDistance(v, 1000, false)} />
      ),
    },
    { field: 'stockUomEan', title: t`EAN`, hasFilter: true },
    { field: 'stockUomUpc', title: t`UPC`, hasFilter: true },
    { field: 'stockUomMaxStack', title: t`Max Stackability`, hasFilter: true },
  ];

  return columnsConfig;
}
export default useSimulationHqDataTableConfig;
